/**
 * Service metadata (non-translatable). Translatable content lives in coaching-portal locale under services.data.<dataKey>.
 */
export const servicesInfo = {
  "app-store-listing": {
    dataKey: "appStoreListing",
    price: "100",
    chips: true,
    link: "https://form.typeform.com/to/RlAlTpBC",
    img: "/img/services/App-Store-Thumbnail.webp",
  },
  "landing-page": {
    dataKey: "landingPage",
    price: 499,
    previewLink: "https://testfit.my.canva.site/landing-pages",
    link: "https://form.typeform.com/to/x3GyuxTf",
    img: "/img/services/Landing page.webp",
  },
  "social-media": {
    dataKey: "socialMedia",
    price: "150 - $400",
    previewLink: "https://testfit.my.canva.site/social-media-portfolio",
    link: "https://form.typeform.com/to/TmZ3FVTj",
    img: "/img/services/Social-Media.webp",
    packagesTiers: true,
  },
  "app-icon": {
    dataKey: "appIcon",
    price: 100,
    link: "https://form.typeform.com/to/u81PIPiM",
    img: "/img/services/App-icons.webp",
    footerLink: "https://form.typeform.com/to/Fm3TuJOF",
  },
  thumbnails: {
    dataKey: "thumbnails",
    price: "75 - $200",
    previewLink: "https://testfit.my.canva.site/thumbnail-portfolio",
    link: "https://form.typeform.com/to/luwRggAY",
    img: "/img/services/Thumbnails.webp",
    packagesList: true,
  },
  "program-quiz": {
    dataKey: "programQuiz",
    price: 199,
    link: "https://form.typeform.com/to/vvcUEAtf",
    img: "/img/services/Program-Recommendation-Quiz.webp",
  },
  "animated-storefront": {
    dataKey: "animatedStorefront",
    price: 50,
    link: "https://form.typeform.com/to/E7YRhNTl",
    img: "/img/services/Animated Banner.mp4",
  },
  "storefront-redesign": {
    dataKey: "storefrontRedesign",
    price: 75,
    link: "https://form.typeform.com/to/cDwwDXF2",
    img: "/img/services/Storefront-and-App-Redesign.webp",
  },
};
